import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformPentestPage from '@src/pages/Platform/Pentest';

export const Route = createLazyFileRoute('/platform/pentest')({
  component: PlatformPentestPageWithLayout,
});

function PlatformPentestPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformPentestPage />
    </DefaultLayout>
  );
}
